import type { MessageInstance } from 'antd/es/message/interface';

type Translate = (key: string, options?: Record<string, unknown>) => string;

/**
 * Surfaces "N routes queued for recompute" as a lightweight toast after a
 * barrier mutation. Silent when nothing was enqueued — chatty success
 * toasts add noise for the common case of editing a barrier that no
 * existing route touches. The global `RecomputeStatusBadge` in the app
 * header renders in parallel; this toast is the immediate, deterministic
 * feedback that doesn't depend on polling cadence.
 */
export function notifyRecomputeEnqueued(
  message: MessageInstance,
  t: Translate,
  enqueued: number,
): void {
  if (enqueued <= 0) return;
  message.info(
    t('recompute.notify.enqueued', { count: enqueued }),
    /* duration seconds */ 3,
  );
}
